import { render, staticRenderFns } from "./EditCheckbox.vue?vue&type=template&id=fa97290c"
import script from "./EditCheckbox.vue?vue&type=script&lang=js"
export * from "./EditCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports